export default {
  sections: {
    address: 'Morada',
    legal_address: 'Morada de registo',
    invoice_address: 'Morada de faturação',
  },
  form: {
    display_name: {
      label: 'Nome de identificação',
      placeholder: 'Introduzir nome de identificação da empresa',
    },
    legal_name: {
      label: 'Nome legal',
      placeholder: 'Introduzir nome legal',
      tooltip: 'Nome de registo. Apresentado em relatórios de pagamento, contrato, etc.',
    },
    timezone: {
      label: 'Fuso horário',
    },
    has_dedicated_invoice_address: {
      label: 'Informação de faturação diferente',
    },
  },
  buttons: {
    next: 'Seguinte',
  },
};
